<template>
    <!-- <div v-if="isVisible" class="update-dialog-container"> -->
    <el-dialog :modal="false" title="版本更新公告" :visible.sync="isVisible" width="50%" :show-close="false" center
        :close-on-click-modal="false" custom-class="update-dialog">
        <div class="update-content">
            <h3 class="version-title">版本号：{{ updateInfo.title }}</h3>
            <div class="content-wrapper">
                <h4>更新内容：</h4>
                <p class="update-detail">{{ updateInfo.content }}</p>
            </div>
        </div>

        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="isVisible = false">我知道了</el-button>
        </span>
    </el-dialog>
    <!-- </div> -->
</template>

<script>
import { EventBus } from '@/utils/event-bus';
import { get_new_notice } from '@/api/UpdateNotice'

export default {
    data() {
        return {
            isVisible: false,
            currentVersion: localStorage.getItem('app_version') || '未知版本',
            latestVersion: '',
            updateInfo: {
                title: '1.0.2',
                content: '新增了详细的功能说明，优化了用户交互，提高了系统稳定性。'
            }
        };
    },
    created() {

        // 监听事件总线中的版本更新通知
        // this.$eventBus.$on('showUpdateDialog', this.showDialog);
        EventBus.$on('showUpdateDialog', this.showDialog);

    },
    methods: {
        async showDialog(version) {
            this.latestVersion = version;
            // 获取更新公告信息（跳过拦截器）
            try {

                get_new_notice().then(res => {
                    if (res.data.code === 200) {
                        this.updateInfo = res.data;
                    } else {
                        this.$message.error('获取更新公告失败');
                    }
                })
                // const response = await axios.get('/api/update-info', {
                //   headers: {
                //     'x-ignore-interceptor': 'true' // 标识该请求跳过拦截器
                //   }
                // });
                // this.updateInfo = response.data.update_info || [];
                this.isVisible = true;
            } catch (error) {
                this.isVisible = true;
            }
            this.isVisible = true;
            this.updateInfo = [
                '修复了已知的几个bug',
                '优化了系统性能',
                '新增了用户反馈功能'
            ];
            // 更新本地存储的版本号
            localStorage.setItem('app_version', this.latestVersion);
        },
        closeDialog() {
            this.isVisible = false;
        }
    },
    beforeDestroy() {
        // 移除事件监听
        // this.$eventBus.$off('showUpdateDialog', this.showDialog);
        EventBus.$off('showUpdateDialog', this.showDialog);
    }
};
</script>

<style scoped>
.update-dialog {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
}

.update-dialog .el-dialog__header {
  background-color: #1989fa;
  color: white;
  padding: 16px 20px;
  border-radius: 8px 8px 0 0;
}

.update-dialog .el-dialog__header h2 {
  font-size: 18px;
  font-weight: 600;
  margin: 0;
}

.update-content {
  padding: 20px;
  background-color: #f8f9fb;
}

.version-title {
  font-size: 18px;
  color: #333;
  margin-bottom: 15px;
  border-bottom: 1px solid #eaeaea;
  padding-bottom: 10px;
}

.content-wrapper {
  font-size: 14px;
  color: #555;
  line-height: 1.6;
}

.update-detail {
  margin-top: 10px;
  white-space: pre-line;
  text-align: justify;
}

.dialog-footer {
  display: flex;
  justify-content: center;
  margin-top: 15px;
}

.update-dialog .el-dialog__footer {
  padding: 15px 20px;
  border-top: none;
}
</style>